export default "__VITE_ASSET__5a8e31aa__"